module.exports = __webpack_public_path__ + "img/code.5cad3766.svg";